/** Date-only deadline, or the midnight-UTC form a date column takes after JSON serialization. */
const CALENDAR_DAY = /^(\d{4})-(\d{2})-(\d{2})(?:T00:00:00(?:\.000)?Z)?$/;

const MS_PER_DAY = 1000 * 60 * 60 * 24;

/**
 * Last instant an offer can be submitted. A deadline is a calendar date, so the
 * supplier has the full day: 23:59:59.999 in the local timezone. Without this,
 * `new Date('2026-10-01')` is UTC midnight and the day is already over at 02:00 CEST.
 */
export function inquiryOfferDeadlineEnd(deadline: string): Date {
  const day = CALENDAR_DAY.exec(deadline);
  if (!day) return new Date(deadline);
  return new Date(Number(day[1]), Number(day[2]) - 1, Number(day[3]), 23, 59, 59, 999);
}

/** Whole days from today to the deadline day: 0 is today, negative is past. */
export function daysUntilInquiryOfferDeadline(deadline: string): number {
  const now = new Date();
  const endOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  // Rounded, so a daylight-saving shift inside the span cannot move the result by a day.
  return Math.round((inquiryOfferDeadlineEnd(deadline).getTime() - endOfToday.getTime()) / MS_PER_DAY);
}
